import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';
import { useState } from 'react';
import If from 'global/ErrorHandlers/If';
import { ProgressRejectedAuthModalContainer } from './styled';
import { AuthModalLoading, VirtualTradingButton } from './components';
import { AuthModalProps, AuthModalType } from './types';
import useAuthModalStore from './store';

export default function ProgressAuthModal({ visible }: AuthModalProps) {
  const closeModal = useAuthModalStore((state) => state.closeModal);

  const [loading, setLoading] = useState(false);

  return (
    <ProgressRejectedAuthModalContainer
      data-cy="progress-auth-modal"
      visible={visible}
      centered
      width={500}
      onCancel={closeModal}
    >
      <If condition={loading}>
        <AuthModalLoading />
      </If>

      <If condition={!loading}>
        <Image
          src="/img/auth-progress.svg"
          alt="Registrasi Kamu Dalam Proses"
        />
        {/* @ts-expect-error */}
        <Text align="center" family="bold" size="16px" mt="30px" mb="13px">
          Registrasi Kamu Dalam Proses
        </Text>
        {/* @ts-expect-error */}
        <Text align="center" mb="30px" color={color.highgray} width="284px">
          Mohon ditunggu sebentar lagi. Registrasi kamu masih dalam tahap
          verifikasi.
        </Text>
        <VirtualTradingButton
          title="Coba Virtual Trading"
          type={AuthModalType.PROGRESS}
          setLoading={setLoading}
        />
      </If>
    </ProgressRejectedAuthModalContainer>
  );
}
